import { RegisterPage } from "@/features/auth/pages/Register";
import { background } from "@/theme/colors";
import { Box } from "@mui/material";

const Register = () => {
  return (
    <Box width="100%" display="flex" minHeight="100vh" justifyContent="center" py={8} bgcolor={background.primary}>
      <RegisterPage />
    </Box>
  );
};

export default Register;
